import React from "react";
import { Modal, Group, Text, Alert } from "@mantine/core";
import { IconX, IconAlertCircle } from "@tabler/icons-react";

function StandardModal({
  isOpen,
  onClose,
  title,
  children,
  footerLeft,
  footerCenter,
  footerRight,
  error = null,
  size = "lg",
  centered = true,
  closeOnClickOutside = true,
  closeOnEscape = true,
  fullScreen = false,
  color = null,
  ...otherProps
}) {
  const hasFooter = footerLeft || footerCenter || footerRight;

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title={
        title && (
          <Text size="lg" fw={600}>
            {title}
          </Text>
        )
      }
      size={size}
      centered={centered}
      closeOnClickOutside={closeOnClickOutside}
      closeOnEscape={closeOnEscape}
      fullScreen={fullScreen}
      closeButtonProps={{
        icon: <IconX size={20} />,
      }}
      styles={{
        header: {
          paddingBottom: "1rem",
        },
        body: {
          padding: hasFooter ? "0 1.5rem" : "0 1.5rem 1.5rem 1.5rem",
        },
        content: {
          borderRadius: fullScreen ? "0" : "8px",
        },
      }}
      {...otherProps}
    >
      {/* Error message */}
      {error && (
        <Alert
          icon={<IconAlertCircle size={16} />}
          color="red"
          variant="light"
          mb="md"
        >
          {error}
        </Alert>
      )}

      {/* Main content */}
      {children}

      {/* Footer */}
      {hasFooter && (
        <Group justify="space-between" align="center" mt="xl" mb="lg">
          <div style={{ display: "flex", alignItems: "center" }}>
            {footerLeft}
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            {footerCenter}
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            {footerRight}
          </div>
        </Group>
      )}
    </Modal>
  );
}

export default StandardModal;
